export const termsAndConditionsLink = 'https://www.tallo.ai/terms-and-conditions';
export const privacyAndPolicyLink = 'https://www.tallo.ai/privacy-policy';
export const transUnionTermsOfUseLink = 'https://files.tallo.ai/public/trans-union-terms-and-conditions.pdf';
export const rentPrepLink = 'https://rentprep.com/';
/** Accepted by the owner (the ordering end user) once per property, never by the applicant. The BE records the same URL. */
export const rentPrepTermsLink = 'https://rentprep.com/terms-conditions/';
/** Where RentPrep sends applicants for their own copy of a report and for disputes (one form for both). */
export const rentPrepRenterRelationsLink = 'https://rentprep.com/resources/renters-relations/';
/** The CFPB's model "Summary of Your Rights Under the FCRA"; this URL serves the current (Mar 2023) revision. */
export const fcraSummaryOfRightsLink =
  'https://files.consumerfinance.gov/f/documents/bcfp_consumer-rights-summary_2018-09.pdf';
export const advertisingForSaleandForRentListingsSimultaneouslyLink =
  'https://help.zillowrentalmanager.com/hc/en-us/articles/213339187-Advertising-For-Sale-and-For-Rent-Listings-Simultaneously';
